module.exports = __webpack_public_path__ + "img/no-search-result.79e6b47e.png";